import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import i18n from 'simple-react-i18n'
import HomeAction from '../../../home/actions/HomeAction'
import Select from '../../../components/forms/Select'
import { CardTitle } from '../../../components/card/NewCard'
import { darkBlue } from '../../../utils/constants/ColorTheme'
import ExportAction from '../../../export/actions/ExportAction'
import ToastrAction from 'toastr/actions/ToastrAction'
import WaitAction from 'wait/WaitAction'
import { getDateExport, getFullDate } from '../../../utils/DateUtil'
import {
    CEMAGREF_EXPORT,
    CSV_EXPORT,
    EXCEL_EXPORT, EXPORT_CEMAGREF_CONST,
    EXPORT_JOB_ID_ONE_OFF,
    EXPORT_JOB_ID_SCHEDULED,
    EXPORT_JOB_STATUS,
    EXPORT_STATIONS_MEASURES,
    EXPORT_STATIONS_MODELS,
    EXPORT_TYPE_OPTIONS_QUALITY,
    MODEL_EXPORT,
} from '../../../export/constants/ExportConstants'
import StationsModelExportPanel from '../../../station/components/StationsModelExportPanel'
import StationsExcelExportPanel from '../../../station/components/StationsExcelExportPanel'
import { CardTable, SORT } from '../../../components/datatable/NewTable'
import ScheduledExportEditModal from '../../../export/components/ScheduledExportEditModal'
import Checkbox from '../../../components/forms/Checkbox'
import Input from '../../../components/forms/Input'
import { setConfirmationModal } from '../../../utils/FormUtils'
import JobAction from '../../../import/actions/JobAction'
import DtojobTable from '../../../import/dto/DtoJobTable'
import { Card, CardContent, Grid } from '@mui/material'
import StationAction from '../../../station/actions/StationAction'
import DtoExportJob from '../../../station/dto/DtoExportJob'
import { intersectionBy, isNil, last, pick } from 'lodash'
import { getLogin } from '../../../utils/SettingUtils'
import { nbPerPageLabelTiny } from '../../../referencial/constants/ReferencialConstants'
import { FILE_LABEL_HEADER, SCHEDULED_FILE_LABEL_HEADER, SCHEDULED_JOB_HEADER, SCHEDULED_NAME_HEADER, getEllipsisCell, getExportDuration, getLoadingBar, getStatusCell, STATUS_HEADER } from '../../../utils/ExportJobUtils'
import { nFormatter } from '../../../utils/NumberUtil'
import { componentHasHabilitations } from '../../../utils/HabilitationUtil'
import { H_QUALITO_EXPORT } from '../../../account/constants/AccessRulesConstants'
import { push } from '@lagunovsky/redux-react-router'
import DtoQualitometer from '../../dto/DtoQualitometer'
import AppStore from '../../../store/AppStore'
import QualityAction from '../../actions/QualityAction'
import { STATION_TYPE_NAME } from '../../../station/constants/StationConstants'
import { searchAllCharacters } from '../../../utils/StringUtil'
import SelectionTableModal from '../../../components/modal/SelectionTableModal'
import { QualitometerFilterField } from '../../../components/datatable/SimpleSelectionTable'
import CityDto from '../../../referencial/components/city/dto/CityDto'
import { createIndex } from '../../../utils/StoreUtils'
import CEMAGREF_ExportPanel from './CEMAGREF_ExportPanel'


class QualitometersExportApp extends Component {
    isCheckingProgress = false
    remainingEmptyChecks = 0

    state = {
        exportType: null,
        model: 0,
        modelStartDate: null,
        modelEndDate: null,
        tmpFilter: {
            startDate: null,
            endDate: null,
            exportDir: 'EXPORT/tmp',
        },
        selectStationIsOpen: false,
        selectedStations: [],
        scheduledOnJob: false,
        name: undefined,
        jobId: EXPORT_JOB_ID_SCHEDULED,
        editJobId: EXPORT_JOB_ID_SCHEDULED,
        jobs: [],
        noZip: false,
        editOpen: false,
        editExport: undefined,
    }

    setTitle = () => {
        this.props.setTitle([{
            title: i18n.quality,
            href: 'quality',
        }, {
            title: i18n.export,
            href: 'quality/export',
        }])
    }

    recursiveFetchExportJob = () => {
        if (!this.isCheckingProgress) {
            return
        }
        this.props.fetchExportJobsTmp('quality').then(response => {
            const isRunning = response.some(e => e.status === EXPORT_JOB_STATUS.WAITING || e.status === EXPORT_JOB_STATUS.IN_PROGRESS)
            this.remainingEmptyChecks = isRunning ? 0 : this.remainingEmptyChecks - 1
            if (isRunning || this.remainingEmptyChecks > 0) {
                setTimeout(() => this.recursiveFetchExportJob(), 5000)
            } else {
                this.isCheckingProgress = false
            }
        })
    }

    regularProgressUpdate = (emptyChecks = 0) => {
        this.remainingEmptyChecks = Math.max(this.remainingEmptyChecks, emptyChecks)
        if (this.isCheckingProgress) {
            return
        }
        this.isCheckingProgress = true
        this.recursiveFetchExportJob()
    }

    componentDidMount() {
        if (!componentHasHabilitations(H_QUALITO_EXPORT)) { // A modifier quand react-router sera à jour
            this.props.push('/unauthorized')
            return
        }
        if (!this.props.qualitometers.length) {
            AppStore.dispatch(QualityAction.fetchQualitometersLight())
        }
        this.setTitle()
        this.props.fetchEnvironmentModelsByType('quality')
        this.regularProgressUpdate()
        JobAction.promiseJobTable({ jobType: 'exportTmpScheduled', displayMode: 'job' })
            .then(jobs => this.setState({ jobs: (jobs?.data ?? []).map(j => new DtojobTable(j)) }))
    }

    componentWillUnmount() {
        this.isCheckingProgress = false
    }

    onChangeFilter = (value) => {
        this.setState(({ tmpFilter }) => ({ tmpFilter: { ...tmpFilter, ...value } }))
    }

    onChange = (value) => {
        this.setState(value)
    }

    onCloseModal = () => {
        this.setState({ selectStationIsOpen: false })
    }

    onApplyExport = (type) => {
        const { tmpFilter, selectedStations, jobId, noZip } = this.state
        const { waitStart, waitStop } = this.props
        waitStart()
        const exportData = {
            exportData: selectedStations.map(h => ({
                station: pick({ ...h, stationType: h.typeName }, ['id', 'code', 'name', 'stationType']),
                exportType: type,
                filename: `${h.code}_${getDateExport()}`,
            })),
            startDate: tmpFilter.startDate,
            endDate: tmpFilter.endDate,
            dataTypes: [{ id: 0, name: 'analysis' }],
            campaign: this.state.campaign,
            threshold: this.state.threshold,
            selectionCode: this.state.selectionCode,
            parameters: this.state.parameters,
            producers: this.state.producers,
            exportDir: tmpFilter.exportDir,
            noZip,
        }
        if (exportData.exportData.length === 0) {
            this.props.toastrWarning(i18n.noDataOverSelectedStationsAndPeriod)
            waitStop()
            return
        }
        if (this.state.scheduledOnJob && (!this.state.name || isNil(this.state.jobId))) {
            this.props.toastrWarning(i18n.pleaseRequiredFields)
            waitStop()
            return
        }
        const exportTmpObj = {
            id: 0,
            exportType: EXPORT_STATIONS_MEASURES,
            jobId,
            login: getLogin(),
            creationDate: 0,
            status: EXPORT_JOB_STATUS.WAITING,
            stationType: 'quality',
            params: JSON.stringify(exportData),
            scheduledOnJob: this.state.scheduledOnJob,
            name: this.state.name,
        }
        this.props.runExportTmp(exportTmpObj).then(() => {
            if (!this.isCheckingProgress) {
                this.regularProgressUpdate()
            }
        })
        if (this.state.editExport) {
            this.props.updateExportTmp({ ...this.state.editExport, params: JSON.stringify(exportData), jobId: this.state.editJobId })
        }
        waitStop()
    }
    onApplyExportModel = (modelFileName) => {
        const { selectedStations, tmpFilter, jobId, noZip } = this.state
        const { waitStart, waitStop } = this.props
        const fileNameSplit = modelFileName.split('.')
        const type = fileNameSplit[fileNameSplit.length - 1]
        waitStart()
        const exportData = {
            exportData: selectedStations.map(h => ({
                station: pick({ ...h, stationType: h.typeName }, ['id', 'code', 'name', 'stationType']),
                exportType: type,
                filename: `${h.code}_${getDateExport()}`,
            })),
            model: modelFileName,
            startDate: this.state.modelStartDate,
            endDate: this.state.modelEndDate,
            campaign: this.state.campaign,
            threshold: this.state.threshold,
            selectionCode: this.state.selectionCode,
            parameters: this.state.parameters,
            producers: this.state.producers,
            exportDir: tmpFilter.exportDir,
            support: tmpFilter.support,
            modeOperation: tmpFilter.modeOperation,
            noZip,
        }

        if (exportData.exportData.length === 0) {
            this.props.toastrWarning(i18n.noDataOverSelectedStationsAndModel)
            waitStop()
            return
        }
        if (this.state.scheduledOnJob && (!this.state.name || isNil(this.state.jobId))) {
            this.props.toastrWarning(i18n.pleaseRequiredFields)
            waitStop()
            return
        }
        const exportTmpObj = {
            id: 0,
            exportType: EXPORT_STATIONS_MODELS,
            jobId,
            login: getLogin(),
            creationDate: 0,
            status: EXPORT_JOB_STATUS.WAITING,
            stationType: 'quality',
            params: JSON.stringify(exportData),
            scheduledOnJob: this.state.scheduledOnJob,
            name: this.state.name,
        }
        this.props.runExportTmp(exportTmpObj).then(() => {
            if (!this.isCheckingProgress) {
                this.regularProgressUpdate()
            }
        })
        if (this.state.editExport) {
            this.props.updateExportTmp({ ...this.state.editExport, params: JSON.stringify(exportData), jobId: this.state.editJobId })
        }
        waitStop()
    }

    onApplyExportCEMAGREF = () => {
        const { selectedStations, tmpFilter, jobId, noZip } = this.state
        const { waitStart, waitStop } = this.props
        waitStart()
        const exportData = {
            exportData: selectedStations.map(h => ({
                station: pick({ ...h, stationType: h.typeName }, ['id', 'code', 'name', 'stationType']),
                exportType: '.xlsx',
                filename: `${h.code}_${getDateExport()}`,
            })),
            model: 'CEMAGREF_MODELE.xlsx',
            startDate: tmpFilter.startDate,
            endDate: tmpFilter.endDate,
            exportDir: tmpFilter.exportDir,
            noZip,
        }

        if (exportData.exportData.length === 0) {
            this.props.toastrWarning(i18n.noDataOverSelectedStationsAndModel)
            waitStop()
            return
        }
        if (this.state.scheduledOnJob && (!this.state.name || isNil(this.state.jobId))) {
            this.props.toastrWarning(i18n.pleaseRequiredFields)
            waitStop()
            return
        }
        const exportTmpObj = {
            id: 0,
            exportType: EXPORT_CEMAGREF_CONST,
            jobId,
            login: getLogin(),
            creationDate: 0,
            status: EXPORT_JOB_STATUS.WAITING,
            stationType: 'quality',
            params: JSON.stringify(exportData),
            scheduledOnJob: this.state.scheduledOnJob,
            name: this.state.name,
        }
        this.props.runExportTmp(exportTmpObj).then(() => {
            if (!this.isCheckingProgress) {
                this.regularProgressUpdate()
            }
        })
        if (this.state.editExport) {
            this.props.updateExportTmp({ ...this.state.editExport, params: JSON.stringify(exportData), jobId: this.state.editJobId })
        }
        waitStop()
    }

    getModelTypesOptions = () => this.props.typeEnvironmentModels
        .filter(t => !t.includes('.xls') || !t.includes('.doc'))
        .map((t, i) => ({ value: i, name: t }))

    resolveExportType = (exportTmp) => {
        if (exportTmp.exportType === EXPORT_CEMAGREF_CONST) return CEMAGREF_EXPORT
        if (exportTmp.exportType === EXPORT_STATIONS_MODELS) return MODEL_EXPORT
        return exportTmp.fileType === 'xlsx' ? EXCEL_EXPORT : CSV_EXPORT
    }

    openEditExport = (exportTmp) => {
        const params = JSON.parse(exportTmp.params ?? '{}')
        const exportType = this.resolveExportType(exportTmp)
        const isModel = exportType === MODEL_EXPORT
        const stations = params.exportData ?? []
        this.setState({
            editOpen: true,
            editExport: exportTmp,
            exportType,
            selectedStations: stations.map(d => ({ ...d.station, typeName: d.station.stationType })),
            model: isModel ? (this.getModelTypesOptions().find(m => m.name === params.model)?.value ?? 0) : 0,
            modelStartDate: isModel ? params.startDate : null,
            modelEndDate: isModel ? params.endDate : null,
            campaign: params.campaign,
            threshold: params.threshold,
            selectionCode: params.selectionCode,
            parameters: params.parameters,
            producers: params.producers,
            noZip: params.noZip ?? false,
            tmpFilter: {
                startDate: params.startDate,
                endDate: params.endDate,
                exportDir: params.exportDir ?? 'EXPORT/tmp',
                support: params.support,
                modeOperation: params.modeOperation,
            },
            editJobId: exportTmp.jobId ?? EXPORT_JOB_ID_SCHEDULED,
            // relance = run ponctuel
            scheduledOnJob: false,
            jobId: EXPORT_JOB_ID_ONE_OFF,
            name: undefined,
        })
    }

    resetForm = () => this.setState({
        exportType: null,
        model: 0,
        modelStartDate: null,
        modelEndDate: null,
        tmpFilter: { startDate: null, endDate: null, exportDir: 'EXPORT/tmp' },
        selectedStations: [],
        campaign: undefined,
        threshold: undefined,
        selectionCode: undefined,
        parameters: undefined,
        producers: undefined,
        jobId: EXPORT_JOB_ID_SCHEDULED,
        editJobId: EXPORT_JOB_ID_SCHEDULED,
        noZip: false,
        scheduledOnJob: false,
        name: undefined,
    })

    closeEditExport = () => {
        this.resetForm()
        this.setState({ editOpen: false, editExport: undefined })
    }

    onSaveAndRunEdit = () => {
        const { exportType, model } = this.state
        if (exportType === MODEL_EXPORT) {
            this.onApplyExportModel(this.getModelTypesOptions().find(m => m.value === model)?.name)
        } else if (exportType === CEMAGREF_EXPORT) {
            this.onApplyExportCEMAGREF()
        } else {
            this.onApplyExport(exportType === EXCEL_EXPORT ? 'xlsx' : 'csv')
        }
        this.closeEditExport()
    }

    getExportPanel = ({ inPopin = false } = {}) => {
        const { exportType, tmpFilter, selectedStations, model, modelStartDate, modelEndDate } = this.state
        const modelTypesOptions = this.getModelTypesOptions()
        if (exportType === MODEL_EXPORT) {
            return (
                <StationsModelExportPanel
                    onApplyExportModel = {this.onApplyExportModel}
                    selectedStations={selectedStations}
                    model={model}
                    modelTypesOptions={modelTypesOptions}
                    onChange={this.onChange}
                    onChangeFilter={this.onChangeFilter}
                    startDate={modelStartDate}
                    endDate={modelEndDate}
                    tmpFilter={tmpFilter}
                    stationType={STATION_TYPE_NAME.quality}
                    producers={this.state.producers}
                    campaign={this.state.campaign}
                    threshold={this.state.threshold}
                    selectionCode={this.state.selectionCode}
                    hideApplyButton={inPopin}
                />
            )
        } else if ([CSV_EXPORT, EXCEL_EXPORT].includes(exportType)) {
            return (
                <StationsExcelExportPanel
                    onChangeFilter={this.onChangeFilter}
                    onChange={this.onChange}
                    onApplyExport={() => this.onApplyExport(exportType === EXCEL_EXPORT ? 'xlsx' : 'csv')}
                    selectedStations={selectedStations}
                    tmpFilter={tmpFilter}
                    dataTypes={[{ id: 0, name: i18n.analysis }]}
                    selectedDataType={0}
                    stationType={STATION_TYPE_NAME.quality}
                    producers={this.state.producers}
                    campaign={this.state.campaign}
                    threshold={this.state.threshold}
                    selectionCode={this.state.selectionCode}
                    hideApplyButton={inPopin}
                />
            )
        } else if (exportType == CEMAGREF_EXPORT) {
            return (
                <CEMAGREF_ExportPanel
                    onChangeFilter={this.onChangeFilter}
                    onChange={this.onChange}
                    onApplyExport={() => this.onApplyExportCEMAGREF()}
                    selectedStations={selectedStations}
                    tmpFilter={tmpFilter}
                    hideApplyButton={inPopin}
                />
            )
        }
        return null
    }

    render() {
        const qualitometersIndex = createIndex(this.props.qualitometers, 'id')
        const toData = (exports) => exports.map(e => ({
            ...e,
            exportTmp: e,
            name: getEllipsisCell(e.name),
            status: getStatusCell(e.status),
            type: { value: e.fileType },
            creationDate: { value: getFullDate(e.creationDate), format: 'dd/MM/yyyy HH:mm:ss', cellType: 'date' },
            lastExecutionDate: { value: getFullDate(e.updateDate), sortValue: e.updateDate, format: 'dd/MM/yyyy HH:mm:ss', cellType: 'date' },
            author: { value: e.login },
            exportName: { value: i18n[e.exportType] },
            fileLabel: getEllipsisCell(last((e.filePath ?? '').split('/'))),
            progression: { value: getLoadingBar(e.status, e.progress, e.filePath) },
            size: { value: nFormatter(e.fileSize) },
            job: getEllipsisCell(this.state.jobs.find(j => j.jobId === e.jobId)?.jobName ?? ''),
            duration: { value: getExportDuration(e) },
        }))
        const dataCurrentExports = toData(this.props.exportJobsTmp.filter(e => !e.scheduledOnJob))
        const dataScheduledExports = toData(this.props.exportJobsTmp.filter(e => e.scheduledOnJob))
        return (
            <Grid container direction='column' spacing={1}>
                <Card>
                    <CardTitle title={ i18n.export } color={ darkBlue } />
                    <CardContent>
                        <Grid container alignItems='center' spacing={1}>
                            <Grid size={2}>
                                <Select
                                    label={i18n.exportName}
                                    options={EXPORT_TYPE_OPTIONS_QUALITY}
                                    onChange={v => this.setState({ exportType: v })}
                                    obligatory
                                    value={this.state.exportType}
                                />
                            </Grid>
                            <Grid size={2} className='padding-top-1'>
                                <Checkbox
                                    label={ i18n.autoProg }
                                    checked={ this.state.scheduledOnJob }
                                    onChange={ v => this.setState({ scheduledOnJob: v, name: undefined, jobId: v ? undefined : EXPORT_JOB_ID_SCHEDULED }) }
                                />
                            </Grid>
                            { this.state.scheduledOnJob && (
                                <>
                                    <Grid size={2}>
                                        <Input
                                            title={ i18n.name }
                                            obligatory
                                            value={ this.state.name }
                                            onChange={ v => this.setState({ name: v }) }
                                        />
                                    </Grid>
                                    <Grid size={3}>
                                        <Select
                                            label={ i18n.job }
                                            options={ this.state.jobs }
                                            onChange={ v => this.setState({ jobId: v }) }
                                            obligatory
                                            value={ this.state.jobId }
                                            keyValue='jobId'
                                            keyLabel='jobName'
                                        />
                                    </Grid>
                                </>
                            ) }
                            <Grid size={3} className='padding-top-1'>
                                <Checkbox
                                    label={ i18n.noZipExport }
                                    checked={ this.state.noZip }
                                    onChange={ v => this.setState({ noZip: v }) }
                                />
                            </Grid>
                        </Grid>
                        { this.getExportPanel() }
                        {/* <SelectStationModal */}
                        {/*     onClose={ this.onCloseModal } */}
                        {/*     selectStationIsOpen={ this.state.selectStationIsOpen } */}
                        {/*     selectedStations={this.state.selectedStations} */}
                        {/*     stationType='quality' */}
                        {/*     onChangeSelectedStation={tmpStations => this.setState({ selectedStations: tmpStations })} */}
                        {/* /> */}
                        <SelectionTableModal
                            isOpen={this.state.selectStationIsOpen}
                            onClose={ this.onCloseModal }
                            title={i18n.stations}
                            onValidate={idsStations => {
                                this.setState({ selectedStations: idsStations.map(id => qualitometersIndex[id]) })
                                this.onCloseModal()
                            }}

                            listData={this.props.qualitometers.map(q => ({ ...q, city: this.props.citiesIndex[q.townCode]?.labelWithCode ?? '' }))}
                            defaultSelectionList={ this.state.selectedStations.map(q => q.id) }

                            listHeaders={['code', 'name', 'city']}
                            listTitle={i18n.nonSelectedStations}
                            selectionListTitle={i18n.selectedStations}
                            maxHeightTable={'48vh'}

                            filterField={({
                                filter,
                                setFilter,
                            }) => (
                                <QualitometerFilterField
                                    filter={filter}
                                    setFilter={setFilter}
                                />
                            )}
                            filterFunction={(list, filterValues) => {
                                const { searchValue, city, filter, resultFilter } = filterValues
                                const searchValueFormat = searchAllCharacters(searchValue)
                                const filter1 = searchValue ? list.filter(p => searchAllCharacters([p.code, p.name].join('   ')).includes(searchValueFormat)) : list
                                const filter2 = city ? filter1.filter(q => q.townCode === city) : filter1
                                return filter && filter !== -1 ? intersectionBy(filter2, resultFilter, 'id') : filter2
                            }}
                        />
                    </CardContent>
                </Card>
                <CardTable
                    title={ i18n.manualExportsInProgress }
                    rows={ dataCurrentExports }
                    headers={ [STATUS_HEADER, FILE_LABEL_HEADER, 'duration', 'size', 'creationDate', 'lastExecutionDate', 'exportName', 'job', 'progression'] }
                    rowsPerPageOptions={ nbPerPageLabelTiny }
                    defaultSort={{ column: 'lastExecutionDate', direction: SORT.DESC }}
                />
                <CardTable
                    title={ i18n.exportsScheduled }
                    rows={ dataScheduledExports }
                    headers={ [STATUS_HEADER, SCHEDULED_NAME_HEADER, SCHEDULED_FILE_LABEL_HEADER, 'duration', 'size', 'creationDate', 'lastExecutionDate', 'exportName', SCHEDULED_JOB_HEADER, 'progression'] }
                    rowsPerPageOptions={ nbPerPageLabelTiny }
                    defaultSort={{ column: 'lastExecutionDate', direction: SORT.DESC }}
                    lineActions={[
                        { icon: 'play_circle_outline', onClick: row => this.props.relaunchExportTmp(row.exportTmp).then(() => this.regularProgressUpdate(4)), tooltip: i18n.relaunch },
                        { icon: 'edit', onClick: row => this.openEditExport(row.exportTmp), tooltip: i18n.edit },
                        { icon: 'delete', onClick: row => setConfirmationModal(() => {
                            StationAction.deleteExportTmp(row.exportTmp).then(() => this.regularProgressUpdate())
                        }), tooltip: i18n.delete },
                    ]}
                />
                <ScheduledExportEditModal
                    open={ this.state.editOpen }
                    onClose={ this.closeEditExport }
                    onSaveAndRun={ this.onSaveAndRunEdit }
                    title={ this.state.editExport?.name ? `${i18n.editExport} - ${this.state.editExport.name}` : i18n.editExport }
                >
                    <Grid container spacing={ 1 }>
                        <Grid size={ 4 }>
                            <Select
                                label={ i18n.exportName }
                                options={ EXPORT_TYPE_OPTIONS_QUALITY }
                                value={ this.state.exportType }
                                disabled
                            />
                        </Grid>
                        <Grid size={ 4 }>
                            <Select
                                label={ i18n.job }
                                options={ this.state.jobs }
                                value={ this.state.editJobId }
                                onChange={ v => this.setState({ editJobId: v }) }
                                keyValue='jobId'
                                keyLabel='jobName'
                            />
                        </Grid>
                    </Grid>
                    { this.getExportPanel({ inPopin: true }) }
                </ScheduledExportEditModal>
            </Grid>
        )
    }
}

QualitometersExportApp.propTypes = ({
    qualitometers: PropTypes.arrayOf(PropTypes.instanceOf(DtoQualitometer)),
    setTitle: PropTypes.func,
    fetchEnvironmentModelsByType: PropTypes.func,
    typeEnvironmentModels: PropTypes.arrayOf(PropTypes.string),
    exportModel: PropTypes.func,
    waitStart: PropTypes.func,
    waitStop: PropTypes.func,
    toastrWarning: PropTypes.func,
    exportJobsTmp: PropTypes.arrayOf(PropTypes.instanceOf(DtoExportJob)),
    fetchExportJobsTmp: PropTypes.func,
    runExportTmp: PropTypes.func,
    relaunchExportTmp: PropTypes.func,
    updateExportTmp: PropTypes.func,
    push: PropTypes.func,
    citiesIndex: PropTypes.objectOf(CityDto),
})

const mapStateToProps = store => ({
    qualitometers: store.QualityReducer.qualitometersLight,
    citiesIndex: store.CityReducer.citiesIndex,
    typeEnvironmentModels: store.ExportReducer.typeEnvironmentModels,
    exportJobsTmp: store.StationReducer.exportJobsTmp,
})

const mapDispatchToProps = {
    setTitle: HomeAction.setTitle,
    fetchEnvironmentModelsByType: ExportAction.fetchEnvironmentModelsByType,
    exportModel: ExportAction.exportModel,
    toastrWarning: ToastrAction.warning,
    waitStart: WaitAction.waitStart,
    waitStop: WaitAction.waitStop,
    fetchExportJobsTmp: StationAction.fetchExportJobsTmp,
    runExportTmp: ExportAction.runExportTmp,
    relaunchExportTmp: ExportAction.relaunchExportTmp,
    updateExportTmp: ExportAction.updateExportTmp,
    push,
}

export default connect(mapStateToProps, mapDispatchToProps)(QualitometersExportApp)
